import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './list';

export const LogsModule = () => {
  return (
    <Switch>
      <Route path="/logs" component={List} />
    </Switch>
  );
};
